module.exports = __webpack_public_path__ + "static/media/game-press-symbol-justice.7b29e7bf.png";